<template>
  <div>
    <div class="tc mb-4">
      <h3>自开彩RTP调整</h3>
    </div>
    <div class="btnarea">
      <Button
        type="primary"
        class="mb-3"
        @click="
          showModal = true;
          type = true;
        "
        >RTP计算方式</Button
      >
      <div>
        <Button class="mr-3" type="primary" @click="timeSetModal = true">RTP定时设置</Button>
        <Button class="mr-3" type="success" :loading="clickLoading" @click="rtpAllSet(1)">RTP一键开启</Button>
        <Button type="error" :loading="clickLoading" @click="rtpAllSet(0)">RTP一键关闭</Button>
      </div>
    </div>
    <lidaTable
      ref="lidaTable"
      :propscolumns="columns"
      :data="filterData"
      :current="current"
      :propsPageSize="50"
    >
      <template v-slot:headerSelect>
        站别类型
        <Select v-model="site" style="width: auto" class="mr-3">
          <Option v-for="item in siteAllList" :value="item.id" :key="item.id">
            {{ item.value }}
          </Option> </Select
        >彩种系列
        <Select v-model="gameKind" style="width: auto">
          <Option v-for="item in gameSeries" :value="item.id" :key="item.id">
            {{ item.value }}
          </Option>
        </Select>
      </template>
    </lidaTable>
    <rtpModal
      :showModal.sync="showModal"
      :type.sync="type"
      :rtpGameName="rtpGameName"
      :targetRtp="targetRtp"
      :gameid="gameid"
      :isRTP="isRTP"
      @getData="getData"
    />
    <Modal
      v-model="timeSetModal"
      :footer-hide="true"
      :closable="false"
    > 
      <div class="lida-table ivu-table-wrapper tiemSetTable">
        <div class="ivu-table ivu-table-small">
          <div class="ivu-table-header">
            <table cellpadding="0" cellspacing="0" border="0">
              <thead>
                <tr>
                  <th class="ivu-table-column-center" colspan="2">{{'RTP定时设置'}}</th>
                </tr>
              </thead>
              <tbody class="ivu-table-tbody">
                <tr class="ivu-table-row" v-for="(it, i) in timeSetList" :key="i">
                  <td class="ivu-table-column-center" width="35%">{{ it.note }}</td>
                  <td class="ivu-table-column-center">
                    <RadioGroup v-if="it.setid == 3" v-model="it.key" class="ma-1">
                      <Radio :label="1">开启</Radio>
                      <Radio :label="0">关闭</Radio>
                    </RadioGroup>
                    <TimePicker
                      v-else
                      v-model="it.key"
                      format="HH"
                      style="width: 60px"
                      :clearable="false"
                      transfer
                      :disabled-minutes="disabledNum"
                      :disabled-seconds="disabledNum"
                      :hide-disabled-options="true"
                      :disabled="timeSetList.find(item => item.setid == 3).key == 0"
                    ></TimePicker>
                  </td>
                </tr>
                <tr class="ivu-table-row">
                  <td class="ivu-table-column-center" colspan="2" style="padding:7px">
                    <Button class="mr-2" type="success" @click="setTimeSet()">{{$t("front.save")}}</Button>
                    <Button @click="timeSetModal = false">{{$t("common.cancel")}}</Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { cFormat } from 'utils'
import GameGroupMethods from 'utils/game-group-methods.js'
import siteGroup from 'utils/site-group.js'
import { mapGetters } from 'vuex'
import common from '@/views/game-lobby/mixins/common.js'
import NP from 'number-precision'

const gameGroupMethods = new GameGroupMethods()
export default {
  name: 'self-lottery-rtp',
  mixins: [common],
  components: {
    rtpModal: () => import('./components/RtpModifyModal')
  },
  data () {
    return {
      targetRtp: 0,
      rtpGameName: '',
      site: 999,
      gameKind: 0,
      gameName: 0,
      apiData: [],
      showModal: false,
      gameid: 0,
      type: false,
      current: 1,
      isRTP: 1,
      clickLoading: false,
      timeSetModal: false,
      timeSetList: []
    }
  },
  computed: {
    ...mapGetters(['getAllGame', 'getmember', 'getpermission']),
    columns () {
      let obj = {
        siteId: {
          title: '站别',
          key: 'siteId',
          align: 'center',
          width: 70,
          sortable: 'custom',
          render: (h, params) => {
            let word = siteGroup.items[params.row.siteId]
            return h('span', word)
          }
        },
        gamekind: {
          title: '彩种系列',
          key: 'gamekind',
          align: 'center',
          sortable: 'custom',
        },
        gamename: {
          title: '游戏名称',
          key: 'gamename',
          align: 'center',
          minWidth: 50,
          sortable: 'custom',
        },
        totostartdaytime: {
          title: '累计起始时间',
          key: 'totostartdaytime',
          align: 'center',
          width: '150',
          sortable: 'custom',
        },
        todayvalue: {
          title: '日总押注',
          key: 'todayvalue',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            return h('p', this.format(params.row.todayvalue))
          },
        },
        todaympaysum: {
          title: '日總派彩',
          key: 'todaympaysum',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            return h('p', this.format(params.row.todaympaysum))
          },
        },
        TodayProfitALoss: {
          title: '日公司盈虧',
          key: 'TodayProfitALoss',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            return h('p', {
              class: this.CheckNegativeNumber(params.row.TodayProfitALoss)
            }, this.format(params.row.TodayProfitALoss))
          },
        },
        todayRTP: {
          title: '日RTP',
          key: 'todayRTP',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            return h('p', params.row.todayRTP + '%')
          },
        },
        totovalue: {
          title: '总押注',
          key: 'totovalue',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            return h('p', this.format(params.row.totovalue))
          },
        },
        totompaysum: {
          title: '總派彩',
          key: 'totompaysum',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            return h('p', this.format(params.row.totompaysum))
          },
        },
        ProfitALoss: {
          title: '公司盈虧',
          key: 'ProfitALoss',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            return h('p', {
              class: this.CheckNegativeNumber(params.row.ProfitALoss)
            }, this.format(params.row.ProfitALoss))
          },
        },
        totoRTP: {
          title: 'RTP',
          key: 'totoRTP',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            const colorState = NP.round(params.row.totoRTP, 4) > params.row.targetRTP
            return h('p', {
              class: {
                'red-text': colorState
              }
            }, NP.round(params.row.totoRTP, 4) + '%')
          },
        },
        targetRTP: {
          title: '目标RTP',
          key: 'targetRTP',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            return h('p', params.row.targetRTP + '%')
          },
        },
        isRTP: {
          title: '启用RTP',
          key: 'isRTP',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            return params.row.isRTP 
              ? h('p', { class: { 'green-text': true } }, '是')
              : h('p', { class: { 'red-text': true } }, '否')
          }
        },
        action: {
          title: 'RTP操作',
          align: 'center',
          width: '220',
          render: (h, params) => {
            const ButtonState = {
              class: 'mr-1',
              props: {
                type: "info",
                disabled: params.row.targetRTP == 0
              }
            }
            return h('span', [
              h('Button', {
                ...ButtonState,
                on: {
                  click: () => {
                    this.showModal = true
                    this.rtpGameName = params.row.gamename
                    this.gameid = params.row.gameid
                    this.targetRtp = params.row.targetRTP
                    this.isRTP = params.row.isRTP
                  }
                }
              }, '调整'),
              h('Button', {
                ...ButtonState,
                on: {
                  click: () => this.$Modal.confirm({
                    title: '提示讯息',
                    content: `此动作会把日RTP归零，确定重置RTP？`,
                    onOk: async () => {
                      try {
                        let obj = {
                          loid: this.getmember.pid,
                          gameid: params.row.gameid,
                          class: 2
                        }
                        let res = await this.$axios.gameLobby.resetrtp(obj)
                        this.$Message.success('已重置日RTP')
                        this.getData()
                      } catch (error) {
                        console.error(error)
                      }
                    }
                  }),
                }
              }, '重置日'),
              h('Button', {
                ...ButtonState,
                on: {
                  click: () => this.$Modal.confirm({
                    title: '提示讯息',
                    content: `此动作会把累计RTP归零，确定重置RTP？`,
                    onOk: async () => {
                      try {
                        let obj = {
                          loid: this.getmember.pid,
                          gameid: params.row.gameid,
                          class: 1
                        }
                        let res = await this.$axios.gameLobby.resetrtp(obj)
                        this.$Message.success('已重置历史RTP')
                        this.getData()
                      } catch (error) {
                        console.error(error)
                      }
                    }
                  })
                },
              }, '重置历史')
            ])
          }
        }
      }
      if (this.getpermission.gameset[1] == 0) {
        delete obj.action
      }
      return obj
    },
    filterData () {
      let obj = JSON.parse(JSON.stringify(this.apiData))
      obj = obj.filter((it, index) => {
        if (this.site !== 999 && this.gameKind !== 0) {
          return it.siteId == this.site && it.catenaId == this.gameKind
        } else if (this.site !== 999) {
          return it.siteId == this.site
        } else if (this.gameKind !== 0) {
          return it.catenaId == this.gameKind
        } else {
          return it
        }
      })
      return obj
    },
    siteAllList() {
      return siteGroup.allSelect()
    },
    disabledNum () {
      let arr = []
      for (let i = 0; i < 60; i++) {
        arr.push(i)
      }
      return arr
    }
  },
  watch: {
    getAllGame: {
      immediate: true,
      handler () {
        this.getData()
      }
    },
    timeSetModal (bool) {
      if (bool) this.getTimeSetList()
    }
  },
  methods: {
    async getData () {
      if (!this.getAllGame.length) return
      try {
        this.current = 1
        let res = await this.$axios.gameLobby.gamertplist()
        if ('status' in res && res.status === 0) return
        this.apiData = res.map(it => {
          let gameobj = this.getAllGame.filter(ait => ait.gameid == it.gameid)[0]
          it.gamekind = gameGroupMethods.catenaGroup(gameobj.catenaId)
          it.TodayProfitALoss = NP.minus(it.todayvalue, it.todaympaysum) // 日公司盈虧
          it.ProfitALoss = NP.minus(it.totovalue, it.totompaysum) // 公司盈虧
          return it
        }).sort((a, b) => b.siteId - a.siteId)
        setTimeout(() => {
          this.$refs.lidaTable.restart(1)
        }, 500);
      } catch (error) {
        console.error(error)
      }
    },
    format (val) {
      return cFormat(val)
    },
    CheckNegativeNumber (value) {
      if (value < 0) return { 'red-text': true }
    },
    async rtpAllSet (value) {
      this.clickLoading = true
      try {
        const data = {
          loid: this.getmember.pid,
          newset: value
        }
        const res = await this.$axios.gameLobby.gameRTPAllSet(data)
        if (res.status != 1) return
        this.$Message.success('修改成功')
        this.getData()
      } catch (error) {
        console.error(error)
      } finally {
        setTimeout(() => {
          this.clickLoading = false
        }, 1000);
      }
    },
    async getTimeSetList () {
      try {
        const res = await this.$axios.gameLobby.gameRTPtimesetList()
        res.forEach(item => {
          if ([4, 5].includes(item.setid)) {
            item.key = item.key.toString()
          }
          item.orikey = item.key
        })
        this.timeSetList = res
      } catch (error) {
        console.error(error)
      }
    },
    async setTimeSet () {
      try {
        const id4key = this.timeSetList.find(item => item.setid == 4).key
        const id5key = this.timeSetList.find(item => item.setid == 5).key
        const ison = this.timeSetList.find(item => item.setid == 3).key

        if (ison && (Number(id4key) == Number(id5key))) return this.$Message.error('RTP定時開啟/關閉時間不能相同')

        const items = this.timeSetList.filter(item => item.orikey !== item.key).map(item => {
          return {
            setid: item.setid,
            newvalue: item.key
          }
        })
        const data = {
          loid: this.getmember.pid,
          items
        }

        const res = await this.$axios.gameLobby.gameRTPtimeset(data)
        if (res.status != 1) return
        this.$Message.success('修改成功')
        this.timeSetModal = false
      } catch (error) {
        console.error(error)
      }
    } 
  },
}
</script>

<style lang="scss">
.btnarea {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.tiemSetTable {
  table {
    width: 100%;
  }
}
.ivu-time-picker-cells-list ul {
  padding: 0;
}
</style>